<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("wms.menu.product") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">
                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>

						 <div class="col-md-2">
                                <base-input>
                                    <el-select v-model="productStatus" :placeholder="$t('status')" >
                                        <el-option v-for="option in StatusTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                    </el-select>
                                </base-input>
                            </div>



						<!-- #223 — two sibling buttons, not a dropdown: the pattern
						     ReportSaleChannelAndProduct.vue:81-95 already ships
						     ("Export" + "Export PowerBI"). Excel first, it is the
						     incumbent. col-lg-4 because two buttons wrap at lg in
						     the old col-lg-3. -->
						<div class="col-lg-4">
							<base-button
								size="md"
								type="primary"
								:disabled="exporting"
								@click="handleExport()"
								>{{ $t("export_excel") }}</base-button
							>
							<base-button
								size="md"
								type="secondary"
								:disabled="exporting"
								@click="handleExportJson()"
								>{{ $t("export_json") }}</base-button
							>
						</div>
						</div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >

							<el-table-column >
									<div slot-scope="{  row }" class="d-flex">
										<img :src="GetProductUrl(row.images)" height="100px" v-if="row.images.includes('.png') || row.images.includes('.jpg') || row.images.includes('jpeg')"/>
									</div>
							</el-table-column>

                            <el-table-column :label="$t('name')" >
								<div slot-scope="{  row }" >
									{{ row.name}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('code')" >
								<div slot-scope="{  row }" >
									{{ row.code}}
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('price')" >
								<div slot-scope="{  row }" >
									{{ row.price}}
								</div>
                            </el-table-column>

                            <!--
                                #299: the ค่าขนส่ง column was here and always
                                rendered blank. `bo_product` has no
                                shipping_cost column and DBProduct
                                (mdf-bo-api/controllers/BO-ProductStruct.go:10-45)
                                has no field for one, so GET /api/v1/product has
                                never sent `shipping_cost` and `row.shipping_cost`
                                was always undefined.

                                Dropped rather than wired to a real field: there
                                is no product-level shipping cost anywhere in the
                                backend. Every `shipping_cost` in mdf-bo-api is on
                                an ORDER (bo_orders.shipping_cost, derived by
                                OrderShippingCostCalculator, BO-Orders.go:2795),
                                and the `shipping_config` work is a per-channel
                                rate table, not a per-SKU cost.

                                The same dead column sat on
                                Admin/PlatformProductTables.vue, which reads the
                                same `Product/getData` rows, and is dropped with
                                it. PlatformProductTableV2.vue had already
                                commented its copy out.
                            -->
                            <el-table-column :label="$t('tag')" >
								<div slot-scope="{  row }" >
									{{ row.tag}}
								</div>
                            </el-table-column>
							<el-table-column :label="$t('status')" >
								<div slot-scope="{  row }" >
									<template v-if="row.status == 1">{{ $t('product_status_active') }}</template>
									<template v-if="row.status == 2">{{ $t('product_status_inactive') }}</template>
								</div>
                            </el-table-column>


                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('name')" v-model="params.name"> </base-input>

                <base-input :label="$t('description')" v-model="params.detail">
                </base-input>


                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from 'xlsx'
import { filterAppCatalogProducts } from "@/utils/appCatalogFilter";
import { requestRefresh } from "@/utils/pageRefresh";
import {
    applySearch,
    buildWmsIndex,
    exportRows,
    jsonPayload,
} from "@/utils/adminProductExport";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            getDataFor: "Product/getDataFor",
            getCurrentPage: "Product/getCurrentPage",
            // #416 F5c: export names SKUs mapped to a disabled product too (active=all)
            WmsProductTable: "WmsProduct/getDataAll"
        }),
        // Own slot per list page (store comment on datasByKey): no cross-tab
        // overwrite between /admin/product, /admin/product/:platform and
        // /admin/product_platform while they are kept alive.
        tableDataOrg() {
            return this.getDataFor("admin_product");
        },
        // #17 — computed, not data(): data() runs once, so labels captured there
        // never follow a language switch. Ids are unchanged (0/1/2) so the
        // filter logic and exportFilterLabel() keep working as before.
        StatusTable() {
            return [
                { id: 0, name: this.$t("all") },
                { id: 1, name: this.$t("product_status_active") },
                { id: 2, name: this.$t("product_status_inactive") },
            ];
        },
        AppFilterTable() {
            return [
                { id: 0, name: this.$t("all") },
                { id: 1, name: this.$t("app_filter_on") },
                { id: 2, name: this.$t("app_filter_off") },
            ];
        },
        // #223 — what BOTH export modes send to the file.
        //
        // The old code mapped `tableData`, which the search box never touches:
        // `searchQuery` lands in `searchedData` (clientPaginationMixin.js:98-105)
        // and the table reads that, so searching "ลิป" and pressing Export gave
        // you all 120 rows. This is `queriedData` without the `.slice()` that
        // makes it one page — the whole filtered set, scoped by the search.
        //
        // DELIBERATE BEHAVIOUR CHANGE to the existing xlsx export (spec §4): the
        // file gets smaller when a search is active. Both modes report the row
        // count on success so the new scope is stated, not discovered.
        exportSource: function() {
            return applySearch(this.tableData, this.searchQuery, this.propsToSearch);
        },
        tableData: function() {
            // Behaviour covered by tests/unit/appCatalogFilter.spec.js
            return filterAppCatalogProducts(this.tableDataOrg, {
                status: this.productStatus,
                appFilter: this.appFilter,
            });
        },
		searchParams: function(){
			return {
				platform_id:1
			}
		}
       
    },
    data() {
        return {
            propsToSearch: ["name", "tag"],
            selectedRows: [],
            showAddModal: false,
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                cod: "",
                code: "",
				atrributes:"",
				tag:"",
				status:1,
				product_sku:"",
            },
			productStatus:1,
			appFilter:0,
			// #223 — the WMS name lookup is fetched on the FIRST export click and
			// cached for the session. Never on mount: the page must not get slower
			// for everyone who never exports.
			exporting: false,
			wmsLoaded: false
        };
    },
    mounted() {
        this.listData(this.searchParams);
		this.pagination.currentPage = this.getCurrentPage
    },
    methods: {
        ...mapActions({
            createData: "Product/createData",
            updateData: "Product/updateData",
            deleteData: "Product/deleteData",
            listDataFor: "Product/listDataFor",
            setCurrentPage: "Product/setCurrentPage",
            listWmsData: "WmsProduct/listData"
        }),
        listData(params) {
            return this.listDataFor({ key: "admin_product", version: "v1", params });
        },
		// #223 — WMS names are resolved lazily, exactly once, the same way
		// ProductForm.vue:471/623-632 does it. The store action swallows its own
		// errors and commits [] (wms_product_module.js:48-62), so a failed fetch
		// cannot fail the export — it just means every wms_product_name is null.
		async ensureWmsIndex(){
			if (!this.wmsLoaded) {
				try {
					await this.listWmsData({ active: "all" });
				} catch (err) {
					console.log("wms lookup failed, exporting without names", err);
				}
				// Marked loaded either way: a second click should not re-try a call
				// that already failed once, it should produce the file.
				this.wmsLoaded = true;
			}
			return buildWmsIndex(this.WmsProductTable);
		},
		exportFilterLabel(table, id){
			const found = (table || []).find((o) => o.id === id);
			return found ? found.name : "";
		},
		// Zero rows must not write a file: an empty workbook looks like an answer.
		exportEmpty(){
			if (this.exportSource.length > 0) return false;
			swal.fire({
				title: this.$t("export_none"),
				icon: "info",
				confirmButtonClass: "btn btn-primary btn-fill",
				buttonsStyling: false
			});
			return true;
		},
		async handleExport(){
			if (this.exportEmpty()) return;
			this.exporting = true;
			try {
				const wmsIndex = await this.ensureWmsIndex();
				const { rows, omittedCodes } = exportRows(this.exportSource, wmsIndex);
				const dataWS = utils.json_to_sheet(rows)
				const wb = utils.book_new()
				utils.book_append_sheet(wb, dataWS)
				writeFile(wb,'export_products_promotion.xlsx')
				// The count is reported on purpose (§4): the search box now narrows the
				// file, and a smaller file should be stated rather than discovered.
				await swal.fire({
					title: this.$t("export_done", { count: rows.length }),
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
				// ONE warning after the file is written, naming the products whose JSON
				// cell was dropped whole rather than truncated (§3.2). Their *Count
				// columns still carry the true size, and JSON mode has no cell limit.
				if (omittedCodes.length > 0) {
					swal.fire({
						title: this.$t("export_excel"),
						text: this.$t("export_cell_limit_warning", { codes: omittedCodes.join(", ") }),
						icon: "warning",
						confirmButtonClass: "btn btn-warning btn-fill",
						buttonsStyling: false
					});
				}
			} finally {
				this.exporting = false;
			}
		},
		// Pure-JSON mode. Pretty-printed and reshaped for a human reader (§3.3) —
		// it is NOT round-trippable and must not be made so (§0): no internal ids,
		// no raw enums, no schema version. It is also the documented escape hatch
		// for a product whose JSON does not fit an Excel cell.
		async handleExportJson(){
			if (this.exportEmpty()) return;
			this.exporting = true;
			try {
				const wmsIndex = await this.ensureWmsIndex();
				const payload = jsonPayload(this.exportSource, wmsIndex, {
					exportedAt: new Date().toISOString(),
					filter: {
						status: this.exportFilterLabel(this.StatusTable, this.productStatus),
						app: this.exportFilterLabel(this.AppFilterTable, this.appFilter),
						search: this.searchQuery || ""
					},
					imageUrl: (images) => this.GetProductUrl(images)
				});
				// Blob + anchor, following the repo's existing client-side download
				// (ReportDashboardByPlatformChannel.vue:1096-1101).
				const blob = new Blob([JSON.stringify(payload, null, 2)], {
					type: "application/json;charset=utf-8"
				});
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "export_products_promotion.json";
				link.click();
				URL.revokeObjectURL(link.href);
				swal.fire({
					title: this.$t("export_done", { count: payload.product_count }),
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
			} finally {
				this.exporting = false;
			}
		},
        // Spec 2026-10-07-bo-form-draft-clear-design.md §5 B1/B2: the form
        // loads the product by the id in its path; requestRefresh marks the
        // arrival as intent so a kept-alive edit tab reloads it.
        handleCreate() {
			requestRefresh("/admin/product/form");
			this.$router.push({ name: "product_form" });
        },
        handleEdit(index, row) {
            this.showAddModal = true;
			this.setCurrentPage(this.pagination.currentPage)
			requestRefresh("/admin/product/form/" + row.id);
			this.$router.push({ name: "product_form", params: { id: row.id } });
        },
        handleUpdate() {
            this.showAddModal = false;
            // Create

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
                this.updateData({id:this.params.id,payload:this.params})
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {

			this.setCurrentPage(this.pagination.currentPage)
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData(this.searchParams);
							this.pagination.currentPage = this.getCurrentPage
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } else {
            }
            this.params.files = files[0];
        },
		GetProductUrl(filename){
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
